import { ResponseModel, handleGetAsync, handlePostAsync, handlePutAsync, handleDeleteAsync } from "../../components/common/commonclass";
import { EndPoint } from "../../components/common/config";
import { handleNotify, TOASTER_POSITION, TOASTER_TYPE } from "../../components/common/notification/toaster_notify.component";

var responseModel = new ResponseModel();

export class TaxGroupService {
    static async getAllTaxGroups(storeId = null) {
        responseModel = new ResponseModel();
        const requestURL = EndPoint.TAXGROUPS; // endpoint
        const requestModel = { storeId };
        responseModel = await handleGetAsync(requestURL, true, requestModel);
        if (responseModel) {
            return responseModel;
        } else {
            console.error('Failed to fetch tax groups.');
            return [];
        }
    }

    // Create
    static async addNewTaxGroup(data) {
        responseModel = new ResponseModel();
        const requestURL = EndPoint.TAXGROUPS; // endpoint

        responseModel = await handlePostAsync(requestURL, true, data);

        if (responseModel) {
            handleNotify('Tax group added successfully!', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            throw new Error('Failed to create new tax group.');
        }
    }

    // Get by ID
    static async getTaxGroupById(id) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.TAXGROUPS}/${id}`; // endpoint

        responseModel = await handleGetAsync(requestURL, true);
        if (responseModel) {
            return responseModel;
        } else {
            throw new Error('Failed to fetch tax group by ID');
        }
    }

    // Update
    static async updateTaxGroupById(id, data) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.TAXGROUPS}/${id}`; // endpoint

        responseModel = await handlePutAsync(requestURL, true, data);
        if (responseModel) {
            handleNotify('Tax group updated successfully.', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            throw new Error('Failed to update tax group.');
        }
    }

    // Delete
    static async deleteTaxGroup(id) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.TAXGROUPS}/${id}`; // endpoint

        try {
            responseModel = await handleDeleteAsync(requestURL, true);
            if (responseModel) {
                return responseModel;
            } else {
                throw new Error('Failed to delete tax group.');
            }
        } catch (error) {
            console.error('Error deleting tax group:', error);
            throw error;
        }
    }

    // Delete by IDs
    static async deleteManyTaxGroups(ids) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.TAXGROUPS}/deletemany`; // endpoint

        responseModel = await handleDeleteAsync(requestURL, true, ids);
        if (responseModel) {
            handleNotify(responseModel.message, TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            handleNotify(responseModel.errormessage, TOASTER_TYPE.ERROR, TOASTER_POSITION.TOP_RIGHT);
        }
    }
}
